/* eslint-disable @typescript-eslint/ban-types */
import { Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import FormToggle from '../../../../../../../Global/Toggle'
import { SingleFieldProps } from '../../../../../../Types'
import { formateBooleanValue } from '../GuarantoType/Utils'
import { useStyles } from './Style'

const QualificationCouple = <T extends {}>({
  field,
  input,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()
  const [situationLeniency, setSituationLeniency] = useState(false)

  const onSituationLeniencyChange = (value: string | boolean) => {
    const newValue = formateBooleanValue(value)
    setSituationLeniency(newValue)

    input.onChange(newValue)
  }

  useEffect(() => {
    const newSituationLeniency = formateBooleanValue(input.value)
    setSituationLeniency(newSituationLeniency)
    input.onChange(newSituationLeniency)
  }, [input.value])

  return (
    <div className={classes.container}>
      {!!field.customProperties?.label && (
        <div className={classes.labelContainer}>
          <Typography className={classes.label}>{field.customProperties?.label}</Typography>
        </div>
      )}

      <div className={classes.toggleContainer}>
        <FormToggle
          label="Situation flexible"
          value={
            formateBooleanValue(field.customProperties?.situationLeniency) ||
            situationLeniency ||
            false
          }
          onChange={onSituationLeniencyChange}
        />
      </div>
    </div>
  )
}

export default QualificationCouple
